<template>
  <div class="w-96 relative leading-tight">
    <input v-model="link" type="text" class="h-12 w-full border-0 bg-transparent pr-12 focus:ring-0" placeholder="New link..." ref="input" @keydown="keydown">

    <div class="absolute right-0 top-0 h-full p-0.5 flex space-x-1">
      <a
        class="rounded-lg border bg-white border-gray-200 w-12 inline-block shrink-0 flex justify-center items-center cursor-pointer hover:bg-gray-50 duration-100 shadow-sm hover:shadow"
        target="_blank"

        :href="fullLink"
      >
        Go
      </a>
      <button class="bg-gray-800 cursor-pointer w-12 hover:brightness-110 shrink-0 rounded-lg flex justify-center items-center text-primary" @click="save">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6">
          <path d="M12 1.5a.75.75 0 01.75.75V7.5h-1.5V2.25A.75.75 0 0112 1.5zM11.25 7.5v5.69l-1.72-1.72a.75.75 0 00-1.06 1.06l3 3a.75.75 0 001.06 0l3-3a.75.75 0 10-1.06-1.06l-1.72 1.72V7.5h3.75a3 3 0 013 3v9a3 3 0 01-3 3h-9a3 3 0 01-3-3v-9a3 3 0 013-3h3.75z" />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>

import { mapGetters } from "vuex"

export default {
  props: ['value'],
  data() {
    return {
      link: this.value,
    }
  },
  mounted() {
    this.$refs.input.focus()
  },
  methods: {
    keydown({ key }) {
      if (key === "Enter") this.save()
    },
    save() {
      console.log(this.withoutBackspaces)
      /* https:/ http:/ */
      this.$emit("set-value", this.withoutBackspaces)
    },
  },
  computed: {
    ...mapGetters({
      domain: 'editor/fullDomainLink',
    }),

    fullLink() {
      const noBackpsace = this.withoutBackspaces
      if (noBackpsace && (noBackpsace.includes("https://") || noBackpsace.includes("http://"))) return noBackpsace
      return `${this.domain}/${noBackpsace}`
    },
    withoutBackspaces() {
      let link = this.link
      if (!link) return;

      // if (link[0] === '/') link = link.substring(1)
      if (link[link.length - 1] === '/') link = link.slice(0, link.length - 1)

      return link
        .replace(/\/\/+/g, "/")
        .replace("https:/", "https://")
        .replace("http:/", "http://")
    },
  },
}

</script>
